"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcNewCanopyCoverPercent = void 0;
/**
 * Calculates the canopy cover percentage of a feature based on it's canopy cover
 *
 * @param oldArea The area that this feature originally was
 * @param oldCoverPercent What percentage of the original feature was covered in trees (range 0.0-1.0)
 * @param additionalArea The area that you are adding on to the area
 * @param additionalCoverPercent What percentage of the new area is covered in trees
 * @returns The percentage of the new area that is covered in trees
 */
function calcNewCanopyCoverPercent(oldArea, oldCoverPercent, additionalArea, additionalCoverPercent) {
    const coveredArea = oldCoverPercent * oldArea + additionalArea * additionalCoverPercent;
    const totalArea = additionalArea + oldArea;
    return coveredArea / totalArea;
}
exports.calcNewCanopyCoverPercent = calcNewCanopyCoverPercent;
